import { useEffect, useState } from "react"; // Import hooks
import Footer from "../Footer/Footer";
import {
  VStack,
  Heading,
  useColorModeValue,
  Spacer,
  useColorMode,
} from "@chakra-ui/react";
import ScheduleDay from "../Schedule/ScheduleDay";
import DayPicker from "../Schedule/DayPicker";
import "../../App.css"; // For fonts

// load data
import itinerary from "../../data/itinerary.json";

export default function HomePage() {
  const [currentDayIndex, setCurrentDayIndex] = useState(0);
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");
  const colorMode = useColorMode().colorMode;

  // if the site is viewed during the trip update the starting date
  useEffect(() => {
    const date = new Date().getDate();
    const month = new Date().getMonth();
    const year = new Date().getFullYear();

    let index = 0;

    // if the site is viewed during the trip update the starting date
    if (month === 4 && year === 2025 && date >= 17 && date <= 21) {
      index = date - 17;
    }

    setCurrentDayIndex(index);
  }, []);

  // set the view height variable for CSS using view height (solves iPhone problem)
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVH();
    window.addEventListener("resize", setVH);
    return () => window.removeEventListener("resize", setVH);
  }, []);

  return (
    <VStack
      minH="calc(var(--vh, 1vh) * 100)"
      maxH="calc(var(--vh, 1vh) * 100)"
      position="relative"
      spacing="0px"
      justify="space-between"
      bg={colorMode === "light" ? "#FFF1F4" : ""}
    >
      <VStack
        px="10px"
        justify="start"
        align="center"
        minH="calc(var(--vh, 1vh) * 100 - 50px)"
        maxH="calc(var(--vh, 1vh) * 100 - 50px)"
        w="100%"
        maxW="500px"
      >
        <Spacer maxH="30px" />
        <Heading
          size="xl"
          color={textColor}
          textAlign="center"
          fontFamily="Lobster Two"
        >
          San Diego Itinerary
        </Heading>
        <Spacer maxH="15px" />
        <DayPicker
          currentDayIndex={currentDayIndex}
          setCurrentDayIndex={setCurrentDayIndex}
        />
        <Spacer maxH="15px" />
        <ScheduleDay day={itinerary[currentDayIndex]} />
      </VStack>
      <Footer />
    </VStack>
  );
}
